export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/bodypartsMergerWorker.ab4f9f41.worker.js");
}
